The longitude of the geographical location.
